import type { App, ComponentPublicInstance } from 'vue';
import type { Sentry } from '../utils/types';

export const initComponentCapture = (app: App, sentry: Sentry) => {
    const ComponentsMixins = {
        errorCaptured(err: unknown, vm: ComponentPublicInstance | null, info: string) {
            sentry.captureException(err, {
                extra: {
                    component: vm?.$options.__file,
                    info,
                },
            });
        },
    };
    app.mixin(ComponentsMixins);
};
